"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InstallationTab = void 0;
exports.getInstallationPanel = getInstallationPanel;

var _preact = require("preact");

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _PanelItems = require("../PanelItems");

var _Message = require("../../../ui-components/Message");

var _ExternalLink = require("../../../ui-components/ExternalLink");

var _AccordionPanel = _interopRequireDefault(require("../../../panel/AccordionPanel"));

var InstallationPanelBody = function InstallationPanelBody(_ref) {
  var isInstalled = _ref.isInstalled,
      onSave = _ref.onSave,
      onCancel = _ref.onCancel,
      onSharedChangeCallback = _ref.onSharedChangeCallback,
      onDomainChangeCallback = _ref.onDomainChangeCallback,
      onClickCallback = _ref.onClickCallback,
      subdomainErrorMessage = _ref.subdomainErrorMessage,
      sharedSecretErrorMessage = _ref.sharedSecretErrorMessage,
      sharedSecret = _ref.sharedSecret,
      domain = _ref.domain,
      onClickManage = _ref.onClickManage,
      onClickUninstall = _ref.onClickUninstall,
      isSavingCredentials = _ref.isSavingCredentials;
  return (0, _preact.h)("div", {
    className: "panel-body-container installation__panel_body"
  }, !isInstalled && (0, _preact.h)("div", {
    className: "panel-body-title"
  }, "Install TheLoops in Customer Communities"), isInstalled && (0, _preact.h)("div", {
    style: {
      marginBottom: '8px'
    }
  }, (0, _preact.h)(_Message.Message, {
    variant: "success",
    fullWidth: true,
    style: {
      padding: '16px'
    }
  }, (0, _preact.h)("div", null, (0, _preact.h)("strong", null, "TheLoops is successfully connected to your Customer Community"), (0, _preact.h)("div", {
    style: {
      marginTop: '8px'
    }
  }, "Your integration is now active. You can manage settings or make changes anytime from the Integration tab.")))), !isInstalled && (0, _preact.h)("div", {
    className: "panel-body-title"
  }, "To install TheLoops, you'll need"), !isInstalled && (0, _preact.h)("div", {
    className: "panel-body-description"
  }, (0, _preact.h)("div", null, (0, _preact.h)("span", {
    className: "text--bold panel-body-description-label"
  }, "Admin permissions:"), (0, _preact.h)("span", {
    className: "panel-body-description-label-meta"
  }, ' ', "Required to generate an API key from your TheLoops dashboard."))), (0, _preact.h)("div", {
    className: "panel-form-input qa-form-subdomain"
  }, (0, _preact.h)(_InputGroup.default, {
    newStyle: true,
    title: "Subdomain",
    meta: "Enter the subdomain where your theLoops instance is hosted, e.g., yoursite.theloops.ai.",
    key: "subdomain",
    error: subdomainErrorMessage,
    required: true,
    showIconBeforeErrorMessage: true,
    qaClasses: "qa-theloops-subdomain",
    value: domain,
    disabled: isInstalled,
    onChangeCallback: function onChangeCallback(e) {
      return onDomainChangeCallback(e.target.value);
    },
    onClick: function onClick() {
      return onClickCallback();
    }
  })), (0, _preact.h)("div", {
    className: "panel-form-input qa-form-api-key"
  }, (0, _preact.h)(_InputGroup.default, {
    newStyle: true,
    title: "Loops Shared Secret",
    meta: "You can generate your Loops Shared Secret from the Org Settings section in your TheLoops organisation settings.",
    key: "sharedSecret",
    error: sharedSecretErrorMessage,
    required: true,
    showIconBeforeErrorMessage: true,
    qaClasses: "qa-theloops-api-key",
    value: sharedSecret,
    disabled: isInstalled,
    onChangeCallback: function onChangeCallback(e) {
      return onSharedChangeCallback(e.target.value);
    },
    onClick: function onClick() {
      return onClickCallback();
    }
  })), isInstalled ? (0, _preact.h)(_PanelItems.ManageInstallationButtons, {
    onClickManage: onClickManage,
    onClickUninstall: onClickUninstall
  }) : (0, _preact.h)(_PanelItems.ActionButtons, {
    onSave: onSave,
    onCancel: onCancel,
    primaryButtonVariantType: "brand",
    primaryButtonText: "Install",
    isLoading: isSavingCredentials
  }));
};

function getInstallationPanel(props) {
  var isInstalled = props.isInstalled,
      onSave = props.onSave,
      onCancel = props.onCancel,
      subdomainErrorMessage = props.subdomainErrorMessage,
      sharedSecretErrorMessage = props.sharedSecretErrorMessage,
      onClickManage = props.onClickManage,
      onClickUninstall = props.onClickUninstall,
      hasUnsavedChanges = props.hasUnsavedChanges,
      onSharedChangeCallback = props.onSharedChangeCallback,
      onDomainChangeCallback = props.onDomainChangeCallback,
      onClickCallback = props.onClickCallback,
      sharedSecret = props.sharedSecret,
      domain = props.domain,
      isSavingCredentials = props.isSavingCredentials;
  return {
    body: (0, _preact.h)(InstallationPanelBody, {
      isInstalled: isInstalled,
      onSave: onSave,
      onCancel: onCancel,
      onClickManage: onClickManage,
      onClickUninstall: onClickUninstall,
      onSharedChangeCallback: onSharedChangeCallback,
      onDomainChangeCallback: onDomainChangeCallback,
      onClickCallback: onClickCallback,
      sharedSecret: sharedSecret,
      domain: domain,
      subdomainErrorMessage: subdomainErrorMessage,
      sharedSecretErrorMessage: sharedSecretErrorMessage,
      isSavingCredentials: isSavingCredentials
    }),
    customClass: 'panel__body_without_header',
    hasUnsavedChanges: hasUnsavedChanges
  };
}

var InstallationTab = function InstallationTab(_ref2) {
  var isInstalled = _ref2.isInstalled,
      onSave = _ref2.onSave,
      onCancel = _ref2.onCancel,
      sharedSecret = _ref2.sharedSecret,
      domain = _ref2.domain,
      onClickManage = _ref2.onClickManage,
      onSharedChangeCallback = _ref2.onSharedChangeCallback,
      onDomainChangeCallback = _ref2.onDomainChangeCallback,
      onClickCallback = _ref2.onClickCallback,
      subdomainErrorMessage = _ref2.subdomainErrorMessage,
      sharedSecretErrorMessage = _ref2.sharedSecretErrorMessage,
      onClickUninstall = _ref2.onClickUninstall,
      hasUnsavedChanges = _ref2.hasUnsavedChanges,
      showUnsavedChangesModal = _ref2.showUnsavedChangesModal,
      displayUnsavedChangedModal = _ref2.displayUnsavedChangedModal,
      closeModal = _ref2.closeModal,
      resetChanges = _ref2.resetChanges,
      isSavingCredentials = _ref2.isSavingCredentials;
  return (0, _preact.h)("div", {
    className: "installation__tab__wrapper"
  }, (0, _preact.h)("div", {
    className: "installation__tab"
  }, (0, _preact.h)(_AccordionPanel.default, {
    defaultActivePanelIndex: 0,
    panels: [getInstallationPanel({
      isInstalled: isInstalled,
      onSave: onSave,
      onCancel: onCancel,
      onSharedChangeCallback: onSharedChangeCallback,
      onDomainChangeCallback: onDomainChangeCallback,
      onClickCallback: onClickCallback,
      onClickManage: onClickManage,
      onClickUninstall: onClickUninstall,
      sharedSecret: sharedSecret,
      domain: domain,
      subdomainErrorMessage: subdomainErrorMessage,
      sharedSecretErrorMessage: sharedSecretErrorMessage,
      isSavingCredentials: isSavingCredentials,
      hasUnsavedChanges: hasUnsavedChanges
    })],
    renderUnsavedChangesModal: displayUnsavedChangedModal
  })), (0, _preact.h)(_PanelItems.UnsavedChangesModal, {
    showUnsavedChangesModal: showUnsavedChangesModal,
    closeModal: closeModal,
    resetChanges: resetChanges
  }), (0, _preact.h)(_ExternalLink.ExternalLink, {
    label: "How to install the TheLoops integration step by step",
    url: "https://help.insided.com/theloops-integration-guide",
    isExternalLinkForToggle: false
  }));
};

exports.InstallationTab = InstallationTab;